import { type HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { switchMap } from 'rxjs/operators';

import { Auth0Service } from '../../oauth0';

export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(Auth0Service);
  return auth.isAuthenticated$.pipe(
    switchMap(isAuthenticated => {
      if (!isAuthenticated) {
        return next(req);
      }
      return auth
        .getTokenSilently()
        .pipe(switchMap(token => next(req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }))));
    })
  );
};
